import { SxProps, Theme } from '@mui/material';

const styles = {
  container: {
    backgroundColor: 'common.lightBackgroundColor',
  },
  subContainer: {
    display: 'flex',
    paddingX: '41px',
    paddingY: '24px',
  },

  buttonContainer: {
    gap: '15px',
    flex: 1,
    position: 'sticky',
    bottom: 0,
    width: '100%',
    paddingY: '16px',
    backgroundColor: 'common.lightBackgroundColor',
    justifyContent: 'flex-end',
    boxShadow: '0px -2px 4px 0px #0000000A',
  },
  saveButton: { marginRight: '47px' },

} satisfies Record<string, SxProps<Theme>>;

export default styles;
